import { render, staticRenderFns } from "./HowItWorksDialog.vue?vue&type=template&id=3d2f5ba8&scoped=true"
import script from "./HowItWorksDialog.vue?vue&type=script&lang=js"
export * from "./HowItWorksDialog.vue?vue&type=script&lang=js"
import style0 from "./HowItWorksDialog.vue?vue&type=style&index=0&id=3d2f5ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2f5ba8",
  null
  
)

export default component.exports